import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './Carousel';
import { Card, CardContent } from './Card';
const REVIEWS = [{
  name: 'Michael T.',
  location: 'Gilbert, AZ',
  text: 'Rinse Kings completely transformed our driveway and walkways. They removed years of oil stains and dirt. The crew was professional and the price was exactly what they quoted.',
  service: 'Driveway Cleaning'
}, {
  name: 'Sarah J.',
  location: 'Scottsdale, AZ',
  text: 'I was worried about pressure washing our stucco home, but their soft wash method was perfect. The house looks brand new, and they were incredibly careful around my landscaping.',
  service: 'House Soft Wash'
}, {
  name: 'David R.',
  location: 'Peoria, AZ',
  text: 'Showed up on time, worked efficiently, and the results speak for themselves. Best exterior cleaning service I have used in the Valley. Highly recommend the royal treatment.',
  service: 'Pool Deck & Patio'
}, {
  name: 'Amanda L.',
  location: 'Phoenix, AZ',
  text: 'They cleaned our commercial storefront and the difference is night and day. Customers have actually commented on how clean the building looks. We set up a recurring schedule.',
  service: 'Commercial Wash'
}];
export function Reviews() {
  return <section id="reviews" className="py-24 bg-[#081120] border-y border-electric/10 overflow-hidden" data-id="element-179">
      <div className="container mx-auto px-4" data-id="element-180">
        <div className="text-center mb-16" data-id="element-181">
          <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-4" data-id="element-182">
            The Royal <span className="text-gold" data-id="element-183">Reviews</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto text-lg" data-id="element-184">
            Do not just take our word for it. See what your neighbors are saying
            about our service.
          </p>
        </div>

        <div className="max-w-5xl mx-auto relative px-12" data-id="element-185">
          <Carousel opts={{
          align: 'start',
          loop: true
        }} className="w-full" data-id="element-186">
            <CarouselContent className="-ml-4" data-id="element-187">
              {REVIEWS.map((review, index) => <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-1/3" data-id="element-188">
                  <Card className="bg-[#0f1f38] border-electric/20 h-full relative overflow-hidden group" data-id="element-189">
                    <div className="absolute -right-4 -bottom-4 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-190">
                      <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-191">
                        <path d="M2 22H22L19 4L15.5 10L12 2L8.5 10L5 4L2 22Z" fill="#F5B81E" data-id="element-192" />
                      </svg>
                    </div>
                    <CardContent className="p-6 flex flex-col h-full relative z-10" data-id="element-193">
                      <div className="flex gap-1 mb-4" data-id="element-194">
                        {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-gold text-gold" data-id="element-195" />)}
                      </div>
                      <Quote className="h-8 w-8 text-electric/30 mb-4" data-id="element-196" />
                      <p className="text-slate-300 mb-6 flex-grow italic" data-id="element-197">
                        "{review.text}"
                      </p>
                      <div className="mt-auto border-t border-electric/20 pt-4" data-id="element-198">
                        <p className="font-bold text-white" data-id="element-199">{review.name}</p>
                        <div className="flex justify-between items-center mt-1" data-id="element-200">
                          <p className="text-sm text-slate-400" data-id="element-201">
                            {review.location}
                          </p>
                          <span className="text-xs font-bold text-electric uppercase tracking-wider bg-navy px-2 py-1 rounded" data-id="element-202">
                            {review.service}
                          </span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="bg-navy border-electric/30 text-white hover:bg-electric hover:text-white -left-4 md:-left-12" data-id="element-203" />
            <CarouselNext className="bg-navy border-electric/30 text-white hover:bg-electric hover:text-white -right-4 md:-right-12" data-id="element-204" />
          </Carousel>
        </div>
      </div>
    </section>;
}